import type { DropdownMenuGroup } from '@common/components';

export const SEARCH_CATEGORY_QUERY_KEY = 'category';

export const DEFAULT_SEARCH_CATEGORY = 'all' as const;

export const SEARCH_CATEGORY_GROUPS: DropdownMenuGroup<string>[] = [
  {
    label: '전체',
    options: [{ value: 'all', label: '전체' }],
  },
  {
    label: '웰로',
    options: [
      { value: 'policy', label: '정책' },
      { value: 'hometown-news', label: '동네소식' },
      { value: 'festival', label: '동네축제' },
      { value: 'policy-info', label: '아티클' },
    ],
  },
  {
    label: '고향사랑기부',
    options: [
      { value: 'gifts', label: '답례품' },
      { value: 'hometown-business', label: '지정기부사업' },
    ],
  },
  {
    label: '특산품',
    options: [{ value: 'welmarket', label: '특산품' }],
  },
];

export const SEARCH_CATEGORY_ITEMS = SEARCH_CATEGORY_GROUPS.flatMap(
  (group) => group.options,
);

export type SearchCategory =
  | 'all'
  | 'policy'
  | 'hometown-news'
  | 'festival'
  | 'policy-info'
  | 'gifts'
  | 'hometown-business'
  | 'welmarket';

export const isSearchCategory = (
  value: string | null | undefined,
): value is SearchCategory =>
  SEARCH_CATEGORY_ITEMS.some((item) => item.value === value);

// 통합 검색을 특정 맥락으로 제한하는 스코프. 현재는 토스/고향사랑기부 진입의 'donation'만.
export type SearchScope = 'donation';

// 도네이션 스코프에서 노출하는 카테고리(고향사랑기부 계열) — 그룹 필터·가드·클램프의 SSOT.
export const DONATION_SEARCH_CATEGORIES = [
  'gifts',
  'hometown-business',
] as const;

export const DEFAULT_DONATION_SEARCH_CATEGORY = 'gifts' as const;

export const isDonationSearchCategory = (
  value: string | null | undefined,
): value is SearchCategory =>
  DONATION_SEARCH_CATEGORIES.some((category) => category === value);

export const getSearchCategoryGroups = (
  scope?: SearchScope,
): DropdownMenuGroup<string>[] => {
  if (scope !== 'donation') {
    return SEARCH_CATEGORY_GROUPS;
  }

  return SEARCH_CATEGORY_GROUPS.map((group) => ({
    ...group,
    options: group.options.filter((option) =>
      isDonationSearchCategory(option.value),
    ),
  })).filter((group) => group.options.length > 0);
};
